import { render, staticRenderFns } from "./FundProjectModal.vue?vue&type=template&id=485b1b50&scoped=true&"
import script from "./FundProjectModal.vue?vue&type=script&lang=js&"
export * from "./FundProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./FundProjectModal.vue?vue&type=style&index=0&id=485b1b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b1b50",
  null
  
)

export default component.exports